import { useState } from "react";

import ClusterList from "./ClusterList";
import Inbox from "./Inbox";
import Stats from "./Stats";

type SubTab = "inbox" | "clusters" | "stats";

const TABS: { id: SubTab; label: string }[] = [
  { id: "inbox", label: "Inbox" },
  { id: "clusters", label: "Clusters" },
  { id: "stats", label: "Stats" },
];

export default function FeedbackPanel() {
  const [tab, setTab] = useState<SubTab>("inbox");
  return (
    <div>
      <div className="mb-4 flex gap-1 rounded-full bg-slate-900 p-0.5 ring-1 ring-slate-800">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`rounded-full px-3 py-1 text-xs transition ${
              tab === t.id
                ? "bg-slate-800 text-slate-100"
                : "text-slate-400 hover:text-slate-200"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === "inbox" && <Inbox />}
      {tab === "clusters" && <ClusterList />}
      {tab === "stats" && <Stats />}
    </div>
  );
}
